export default __webpack_public_path__ + "static/media/mosasaurus.926d0524.png";